var React = require('react');

function PersonIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2F3641","fillRule":"evenodd","d":"M16,16 C12.1340068,16 9,12.8659932 9,9 C9,5.13400675 12.1340068,2 16,2 C19.8659932,2 23,5.13400675 23,9 C23,12.8659932 19.8659932,16 16,16 Z M10.0996105,20.298024 C13.9297213,19.0226873 18.0700571,19.0233524 21.899758,20.2999193 L26.8090629,21.9363543 C28.7146596,22.5715532 30,24.3548678 30,26.363543 L30,30 L2,30 L2,26.3596855 C2,24.3504585 3.28603523,22.566784 5.19235938,21.932023 L10.0996105,20.298024 Z"}));
}

PersonIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = PersonIcon;

PersonIcon.default = PersonIcon;
